<script setup>
/**
 * The case type a case belongs to — the workspace-defined process that decides
 * its workflow, its fields and who can see it. Neutral by design: the type
 * names a process, the stage carries the colour.
 */
import { computed } from 'vue';

import Icon from 'dashboard/components-next/icon/Icon.vue';
import Label from 'dashboard/components-next/label/Label.vue';

const props = defineProps({
  caseType: {
    type: Object,
    required: true,
  },
  compact: {
    type: Boolean,
    default: true,
  },
});

const name = computed(() => props.caseType?.name || '');
</script>

<template>
  <Label
    :label="name"
    color="slate"
    :compact="compact"
    data-testid="case-type-badge"
  >
    <template #icon>
      <Icon
        icon="i-lucide-shapes"
        class="flex-shrink-0 size-3 text-n-slate-11"
      />
    </template>
  </Label>
</template>
